export const splitWords = words => {
  if (!words) return [];
  const preresult = words.split(/\r\n/).join("\n");
  return preresult.split(/[\f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/);
};
